import { Link } from 'react-router-dom'
import { Button, Text } from '@/ui'

import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { TypographyStyles } from '@/styles'

const UserTransactionsHeader = ({
  headerDescription,
  backlink,
}: {
  headerDescription: string
  backlink: string
}) => (
  <div className="flex items-center justify-between py-2 userRecordHeader">
    <div className="flex items-center gap-4">
      <Link to={backlink}>
        <Button variant="ghost" iconLeft={faArrowLeft} />
      </Link>
      <Text variant={TypographyStyles.H3}>{headerDescription}</Text>
    </div>
  </div>
)

export default UserTransactionsHeader
